import Vue from 'vue';
// Por ahora sólo tenemos una directiva, si tuvieramos más podríamos
// sacar cada una a su respectivo fichero.
export default () => {
  Vue.directive('cursor', {
    bind: (el, { arg }) => {
      el.style.cursor = arg ?? 'pointer';
    }
  });
  Vue.directive('disable', {
    bind: (el, { value }) => {
      if (value) {
        el.style.cursor = 'not-allowed';
      }
    }
  });
  Vue.directive('click-outside', {
    bind: function (el, { expression }, vnode) {
      el.onClick = evt => {
        // Comprobamos que el elemento clickado no es el propio panel para evitar
        // cerrarlo si lo clickamos y también comprobamos que el elemento no sea un input
        // Ahora sólo se usa en la página de autor, es propenso a errores si lo usamos
        // en otras páginas/componentes.
        if (!(el == evt.target || el.contains(evt.target)) && !(evt.target instanceof HTMLInputElement)) {
          vnode.context[expression]();
        }
      };
      document.addEventListener('click', el.onClick);
    },
    unbind: function (el) {
      document.removeEventListener('click', el.onClick);
    },
  });
};